import React from 'react';
import { Box, Card, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PriceDisplay } from './PriceDisplay';

const BoxWithTitle = ({
    title,
    text,
    style,
    titleBoxColor,
    width = 'fit-content',
    variant = 'h4',
    withCurrency
}) => {

    const useStyles = makeStyles((theme) => ({
        root: {
            width: `${theme.spacing(25)}px`,
        },
        ttlContainer: {
            backgroundColor: titleBoxColor,
            padding: `${theme.spacing(1.5)}px`,
        },
        ttl: {
            color: titleBoxColor === '#9900CC' ? 'white' : '',
            fontWeight: 'bolder',
            fontFamily: 'Poppins',
            fontSize: `${theme.spacing(2)}px`,
        },
        txt: {
            // margin: `${theme.spacing(2)}px 0`,
            margin: 'auto',
            padding: `${theme.spacing(3)}px`,
            fontSize: `${theme.spacing(4.5)}px`,
            fontFamily: 'PoppinsBold',
            fontWeight: 'bolder',
            textAlign: 'center',
            width: width,
        },
    }));

    const { root, ttlContainer, ttl, txt } = useStyles();

    return (
        <Card elevation={5} className={root}>
            <Box className={ttlContainer}>
                <Typography className={ttl}>
                    {title}
                </Typography>
            </Box>

            <Typography
                variant={variant}
                className={txt}
                style={style}
            >
                {withCurrency
                    ? <PriceDisplay value={+text} currency={'$'} />
                    : text
                }
            </Typography>
        </Card>
    );

};

export default BoxWithTitle;
